import Vue from 'vue'
import Vuex from 'vuex'
import api from './modules/api'
import countries from './modules/countries'
import dojos from './modules/dojos'
import members from './modules/members'
import events from './modules/events'
import rankings from './modules/rankings'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    info: 0
  },
  mutations: {
    setInfo (state, target) {
      state.info = target
    }
  },
  getters: {
    info: state => state.info
  },
  modules: {
    api,
    countries,
    dojos,
    events,
    members,
    rankings
  },
  strict: debug
})
